/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Plan_Notice_TitleInputs */



/**
* | output |
* | --- |
* | "Your trial has ended" |
*
* @param {Free_Plan_Notice_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const free_plan_notice_title = /** @type {((inputs?: Free_Plan_Notice_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Plan_Notice_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre essai est terminé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Testphase ist beendet")
	if (locale === "it") return /** @type {LocalizedString} */ ("La tua prova è terminata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пробный период закончился")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tu prueba ha terminado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您的试用期已结束")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トライアル期間が終了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपका ट्रायल खत्म हो गया है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O seu período experimental terminou")
	return /** @type {LocalizedString} */ ("Your trial has ended")
});